import { render, staticRenderFns } from "./NewFeature.vue?vue&type=template&id=46fce825"
import script from "./NewFeature.vue?vue&type=script&lang=js"
export * from "./NewFeature.vue?vue&type=script&lang=js"
import style0 from "./NewFeature.vue?vue&type=style&index=0&id=46fce825&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports